'use client'
import classNames from 'classnames'
import type { ParamValue } from 'next/dist/server/request/params'
import styles from './Breadcrumbs.module.scss'
import { ChevronForwardIcon, Hyperlink, IconSize } from '@/tools/ui'

export type BreadcrumbRoutes = { name: string | ParamValue; path: string }[]

interface Props {
  routes: BreadcrumbRoutes
  className?: string
}

export function Breadcrumbs({ routes, className }: Props) {
  return (
    <div className={classNames(styles.wrapper, 'pintxo-typography-body2', className)}>
      {routes.map((crumb, i) => {
        if (!crumb.name) {
          return null
        }
        if (i === routes.length - 1) {
          return (
            <span key={crumb.path} className={styles.inactive}>
              {crumb.name}
            </span>
          )
        }
        return (
          <span key={crumb.path} className={styles.link}>
            <Hyperlink href={crumb.path}>{crumb.name}</Hyperlink>
            <ChevronForwardIcon size={IconSize.small} />
          </span>
        )
      })}
    </div>
  )
}
